import { z } from 'zod';
import { templateAdvanceLogicV1Schema } from './advance-logic';
import { templateNamedWidgetSchema } from './base';
import { fieldLayoutShape } from './field-layout';
import { templateParameterV1Schema } from './parameter';
import { templateReferenceV1Schema } from './reference';
import { TEXT_COLOR_VALUES, templateTextColorSchema } from './typography';

export const templateDatePickerSchema = templateNamedWidgetSchema.extend({
  type: z.literal('datePicker'),
  isRequired: z.boolean(),
  labelColor: templateTextColorSchema.default(TEXT_COLOR_VALUES.BLACK),
  value: z.string().nullable(),
  placeholder: z.string(),
  withTime: z.boolean(),
  defaultNow: z.boolean(),
  enableLessThanTodayRule: z.boolean(),
  parameter: templateParameterV1Schema.optional(),
  reference: templateReferenceV1Schema,
  ...fieldLayoutShape,
  advanceLogics: templateAdvanceLogicV1Schema,
});

export type TemplateDatePickerV1 = z.infer<typeof templateDatePickerSchema>;
